// extracted by mini-css-extract-plugin
export var back = "PostSidebar-module--back--Yw2T3";
export var list = "PostSidebar-module--list--Mjsf4";